export default __webpack_public_path__ + "static/media/settings.c0c11ac6.svg";